<template>
  <h1>Unternehmen</h1>

  <hr class="my-2" />

  <EditUnternehmenModal :index="0" />

  <div v-if="unternehmenStore.unternehmen.length === 0" class="alert alert-info mt-3">Es wurden noch keine Unternehmen erstellt.</div>

  <div v-else class="mt-3">
    <div class="row mb-1 mx-0 fw-bold">
      <div class="col my-auto">Unternehmen</div>
      <div class="col my-auto">Realm</div>
    </div>

    <UnternehmenRow v-for="(unternehmen, index) in sortedUnternehmen" :key="unternehmen.id" :unternehmen="unternehmen" :index="index" />
  </div>
</template>

<script lang="ts" setup>
  //#region Imports
  import { onMounted, computed } from 'vue';
  import { useUnternehmenStore } from '@/stores/unternehmenStore';

  import { Unternehmen } from '@/models/UnternehmenModels';

  import EditUnternehmenModal from '@/components/Unternehmen/EditUnternehmenModal.vue';
  import UnternehmenRow from '@/components/Unternehmen/UnternehmenRow.vue';
  //#endregion

  const unternehmenStore = useUnternehmenStore();
  const sortedUnternehmen = computed(() => unternehmenStore.unternehmen.slice().sort((a: Unternehmen, b: Unternehmen) => a.titel.localeCompare(b.titel)));

  onMounted(async () => {
    await unternehmenStore.getUnternehmen();
  });
</script>
